import NewCookiePolicy from './newCookiePolicy';

export default NewCookiePolicy;
